import { render, staticRenderFns } from "./wc-ui-config.vue?vue&type=template&id=bcb7db22"
import script from "./wc-ui-config.vue?vue&type=script&lang=js"
export * from "./wc-ui-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports